import { Link } from 'react-router-dom';
import { CURRENCY } from '@voladeum/client';
import { CandleValidation } from 'client/voladeum/candle-validations/types';
import { CandleWorker } from 'client/voladeum/candle-workers/types';
import { useGridColumnContext } from 'framework/Grid/context/GridColumnContext';
import { useGridRowContext } from 'framework/Grid/context/GridRowContext';
import { createQuery } from 'utils/queries';

import { CRYPTO_PATH } from '../../constants';

import cn from './Cell.module.scss';

const { PUBLIC_URL } = process.env;

export const GridPairJobCell = () => {
  const { row } = useGridRowContext<CandleValidation | CandleWorker>();
  const { column } = useGridColumnContext();

  return (
    <Link
      className={cn.cell}
      to={`/application/pairs/${row.pair_id}${createQuery({
        since_milliseconds: row.since_milliseconds,
        to_milliseconds: row.to_milliseconds,
      })}`}
      style={{ justifyContent: column.text_align }}
    >
      <img
        src={`${PUBLIC_URL}/cryptocurrencies/${CRYPTO_PATH[row.base_currency_id as CURRENCY]}.svg`}
        alt={row.base_currency_name}
      />
      <div className={cn.stacked}>
        <span>{row.pair_name}</span>
        <span className={cn.small}>{row.base_currency_name}</span>
      </div>
    </Link>
  );
};
